import { makeStyles } from '@material-ui/core';

const resolveColor = (color, colorPalette) => {
  if (!color) return colorPalette.secondary[50];

  switch (color) {
    case 'primary':
      return colorPalette.primary[100];
    case 'secondary':
      return colorPalette.secondary[50];
    default:
      return color;
  }
};

export default makeStyles(theme => ({
  container: {
    borderRadius: theme.shape.borderRadiusLarge,
    background: ({ color }) => resolveColor(color, theme.palette),
    padding: theme.spacing(2.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: ({ centered }) => centered && 'center',
    width: '100%',
    cursor: ({ disableRipple }) => disableRipple && 'auto',
    border: '1px solid rgba(16, 24, 40, 0.06)',
    boxShadow: '0 10px 26px rgba(16, 24, 40, 0.07)',
    transition: theme.transitions.create(['transform', 'box-shadow'], {
      duration: theme.transitions.duration.shorter,
    }),
    '@media (hover: hover)': {
      '&:hover': {
        transform: ({ disableRipple }) => (disableRipple ? 'none' : 'translateY(-2px)'),
        boxShadow: '0 14px 30px rgba(16, 24, 40, 0.1)',
      },
    },
  },
  tile: {
    display: 'grid',
    gridGap: theme.spacing(2),
    justifyContent: 'stretch',
    minWidth: '220px',
  },
  children: {
    marginLeft: theme.spacing(4),
  },
}));
